const goalieStickOverrides = {
  Hand: {
    "Full Right": "right",
    Regular: "left",
  },
  Pattern: {
    P31H: "P31",
  },
};

const playerStickOverrides = {
  Color: {
    "Blue/Red": "bluered",
  },
  Flex: {
    "65S": "65",
    "65sr": "65",
    "65 SR": "65",
  },
};

export default function getParamsForFetchInventory({ addToOrderValues }) {
  if (addToOrderValues.product === "GoalieStick") {
    const { ProductFamily, Pattern } = addToOrderValues;
    const gColor =
      addToOrderValues["Shaft Color"] || addToOrderValues["Outline Color code"];
    const gHand = addToOrderValues["Hand (aka curve or handedness)"];
    const gLength = addToOrderValues["Paddle Length"];

    const goalieStickParams = [
      ProductFamily,
      goalieStickOverrides.Color?.[gColor] || gColor,
      goalieStickOverrides.Hand?.[gHand] || gHand,
      goalieStickOverrides.Length?.[gLength] || gLength,
      goalieStickOverrides.Pattern?.[Pattern] || Pattern,
    ];

    return goalieStickParams.join("-").toLowerCase();
  }

  // For Player Sticks
  const { ProductFamily, Color, Hand, Flex, Pattern, Size } = addToOrderValues;

  const playerStickParams = [
    ProductFamily,
    playerStickOverrides.Color?.[Color] || Color,
    playerStickOverrides.Hand?.[Hand] || Hand,
    playerStickOverrides.Flex?.[Flex] || Flex,
    playerStickOverrides.Pattern?.[Pattern] || Pattern,
    playerStickOverrides.Size?.[Size] || Size,
  ];

  return playerStickParams.join("-").toLowerCase();
}
